/* global $ */
import { equalStr } from './cegep.utils'
import { resizePageElems } from './cegep.resize'

// Défilement pour les ancres
function scrollToAnchor (elem, speed) {
  const menuHeight = 70
  const targetHash = elem.attr('href')
  const targetName = targetHash.slice(1)
  const attributes = ['name', 'id'] // Compatibilité des 2 méthodes d'ancres

  for (let i = 0; i < attributes.length; i++) {
    $('[' + attributes[i] + ']').each(
      function () {
        if (equalStr($(this).attr(attributes[i]), targetName)) {
          $('html,body').animate({
            scrollTop: $(this).offset().top - menuHeight
          }, speed)
          fixIEscroll(targetHash)
        }
      })
  }
}

// Clic sur un onglet ou ancre
$('a[href^="#"]:not(.open-program-type):not([class^="show-"]):not(.main-nav__top-level-link )').click(function (e) {
  e.preventDefault()
  window.location.hash = e.target.getAttribute('href').split('?')[0].slice(1)

  if (!$(this).hasClass('js-tab-trigger')) { // pas un onglet
    scrollToAnchor($(this), 600)
  }

  hideFromAnchor()
  resizePageElems()
})

// Masquer des éléments qui ont une classe identique à l'ancre dans l'URL
function hideFromAnchor () {
  if (window.location.hash.length > 0) {
    const hash = window.location.hash.split('?')[0]
    $('.' + hash.slice(1)).each(function () {
      if (this.classList.value !== 'footer') {
        $(this).hide()
      }
    })
  }
}

(function () {
  hideFromAnchor()
})()

// CLEAR MAIN-MENU ON HASH NAV

// Bugfix IE8 - IE10 (Repositionnement automatique après l'execution de tous les scripts)
function fixIEscroll (hash) {
  if ($(window).scrollTop() === 0) {
    if (document.location.hash) {
      window.location = hash
    }
  }
}

document.onreadystatechange = function () {
  // Afficher la timeline dans les StaticPagesWithTabs
  $('.cd-horizontal-timeline').css('display', '')

  // Repositionner le scroll lors de hash requests
  if (window.location.hash) {
    if (document.readyState === 'complete') {
      const menuHeight = $('#main-nav').height()
      const hash = window.location.hash.split('?')[0]

      // Onglets
      $(window).on('load', function () {
        let foundHashMatch = false

        $('button[role="tab"]').each(function () {
          if (equalStr('#' + $(this).attr('aria-controls'), hash)) {
            foundHashMatch = true
            fixIEscroll(hash)
            const yOffset = $(this).parent().offset().top - menuHeight
            $('html, body').animate({ scrollTop: yOffset }, 300)
            return false
          }
        })

        if (!foundHashMatch) {
          $('a[href^="#"]').each(function () {
            if (equalStr($(this).attr('href'), hash)) {
              scrollToAnchor($(this), 0)
            }
          })
        }
      })

      // Liste de programmes
      $('h2[id^="sessions"], h2[id^="diplomes"], h2[id^="attestations"], h2[id^="cours"], h2[id^="reconnaissance"], .program-type h3[id], .program-type h4[id]').each(
        function () {
          if (equalStr($(this).attr('id'), hash.substring(1))) {
            fixIEscroll(hash)
            const yOffset = $(this).parent().offset().top - menuHeight
            $(window).scrollTop(yOffset)
          }
        })

      hideFromAnchor()
    }
  }
}

// Afficher la timeline lors de navigation par onglets
$('button[role="tab"]').click(function () {
  $('.cd-horizontal-timeline').css('display', '')
})
